<template>
  <div class="main">
    <component v-for="(item, index) in data" :key="index" :is="item"></component>
  </div>
</template>

<script>
export default {
  computed: {
    data () {
      return this.$store.state.globalLayers
    }
  }
}
</script>

<style lang="sass" scoped>
.main
  position: relative
</style>
